import { isEmpty } from 'lodash';

import createReducer from 'legacy-src/shared/util/createReducer';
import {
  fetchAssessments,
  fetchSubjects,
  fetchCategories,
  fetchGroupedAssignments,
  RESET_ASSESSMENT_STATE,
  ADD_QUESTION_TO_STATE,
  ADD_QUESTIONS_LIST_TO_STATE,
  REMOVE_NEW_ITEM_FROM_STATE,
} from './actions';

const initialState = {
  loadingAssessments: false,
  loadingAssignment: false,
  loadingAssignments: false,
  loadingSubjects: false,
  loadingCategories: false,
  loadingResults: false,
  loadingGroupedAssignments: false,
  activeAssignment: null,
  assignments: {
    assignments: [],
    options: {
      groups: [],
      status: [],
    },
  },
  itemsData: {
    items: [],
    total: 0,
  },
  itemData: null,
  subjects: [],
  results: {
    results: [],
    options: {
      groups: [],
    },
  },
  categories: {},
  groupedAssignmentsData: {
    assessments: [],
  },
  newItem: {},
};

const reducer = createReducer(initialState, {
  [RESET_ASSESSMENT_STATE]: () => initialState,
  /**
   * Fetch Assessments
   */
  [fetchAssessments.request]: (state) => ({
    ...state,
    loadingAssessments: true,
  }),
  [fetchAssessments.success]: (state, { payload }) => ({
    ...state,
    itemsData: payload,
    loadingAssessments: false,
  }),
  [fetchAssessments.failure]: (state) => ({
    ...state,
    loadingAssessments: false,
  }),

  [ADD_QUESTIONS_LIST_TO_STATE]: (state, { payload, showNewItem }) => {
    let { items: itemsList, total } = payload;
    const isNewItemInFetchedItems =
      !isEmpty(state.newItem) &&
      !!itemsList.find((item) => item.item_id === state.newItem.item_id);
    if (!isEmpty(state.newItem) && !isNewItemInFetchedItems && showNewItem) {
      itemsList = [state.newItem, ...itemsList];
      total += 1;
    }
    return {
      ...state,
      itemsData: {
        ...payload,
        items: itemsList,
        total,
      },
      loadingAssessments: false,
    };
  },

  [ADD_QUESTION_TO_STATE]: (state, { payload }) => ({
    ...state,
    newItem: payload,
    loadingAssessments: false,
  }),

  [REMOVE_NEW_ITEM_FROM_STATE]: (state) => ({
    ...state,
    newItem: {},
  }),

  /**
   * Fetch Subjects
   */
  [fetchSubjects.request]: (state) => ({
    ...state,
    loadingSubjects: true,
  }),
  [fetchSubjects.success]: (state, { payload }) => ({
    ...state,
    subjects: payload,
  }),
  [fetchSubjects.failure]: (state) => ({
    ...state,
    loadingSubjects: false,
  }),

  /**
   * Fetch Categories
   */
  [fetchCategories.request]: (state) => ({
    ...state,
    loadingCategories: true,
  }),
  [fetchCategories.success]: (state, { payload }) => ({
    ...state,
    categories: payload,
    loadingCategories: false,
  }),
  [fetchCategories.failure]: (state) => ({
    ...state,
    loadingCategories: false,
  }),

  /**
   * Fetch Grouped Assignments
   */
  [fetchGroupedAssignments.request]: (state) => ({
    ...state,
    loadingGroupedAssignments: true,
  }),
  [fetchGroupedAssignments.success]: (state, { payload }) => ({
    ...state,
    groupedAssignmentsData: payload,
    loadingGroupedAssignments: false,
  }),
  [fetchGroupedAssignments.failure]: (state) => ({
    ...state,
    loadingGroupedAssignments: false,
  }),
});

export default reducer;
